<script>
// import widgetWrapper from './widget-wrapper.vue'
// import * as $3Dmol from '3dmol/build/3Dmol.js'
// import * as $33dmol from '3dmol/build/3Dmol-nojquery.js'
export default {
  props: {
    cifcontent: String,
    isaddcell: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pdb: '1MO8',
      background: 'white',
      style: 'sphere',
      message: ''
    }
  },
  created () {
    // import('3dmol/build/3Dmol.js').then(({ default: $3Dmol }) => {
    //   this.widgetLayer = $3Dmol.createModel(this.pdb, this.background, this.style)
    //   this.widgetLayer.addToViewer(this.$store.getters.viewer)
    // })
    // window.ttdmol = ttdmol
    // const s = document.createElement('script')
    // s.type = 'text/javascript'
    // s.src = 'https://3Dmol.org/build/3Dmol-min.js'
    // document.body.appendChild(s)
    // this.message = `
    //     <div style="height: 400px; width: 400px; position: relative;" class='viewer_3Dmoljs' data-pdb='2POR' data-backgroundcolor='0xffffff' data-style='stick' ></div>
    //   `
    // var cifstring = this.cifcontent
    // this.$loadScript('https://3Dmol.org/build/3Dmol-min.js').then(
    //   () => {
    //     $(function () {
    //       let element = $('#container-01')
    //       let config = { backgroundColor: 'black' }
    //       let viewer = $3Dmol.createViewer(element, config)
    //       // viewer.addSphere({ center: {x: 0, y: 0, z: 0}, radius: 10.0, color: 'green' })
    //       // viewer.zoomTo()
    //       // viewer.render()
    //       // viewer.zoom(0.8, 2000)
    //       let cif = cifstring
    //       window.viewer = viewer
    //       // var ViewUrl = 'http://127.0.0.1:5000' + '/cif/' + '62244b018e7fa581ef3b9c19'.trim()
    //       // $.get(ViewUrl, function (cif) {
    //       //   console.log(cif)
    //       //   viewer.addModel(cif, 'cif', {doAssembly: true, duplicateAssemblyAtoms: true})
    //       //   viewer.setStyle({sphere: {colorscheme: 'Jmol', scale: 0.5}, stick: {colorscheme: 'Jmol'}})
    //       //   viewer.addUnitCell()

    //       //   viewer.zoomTo()
    //       //   viewer.render()
    //       // });
    //     })
    //   }
    // )
  },
  methods: {
    updateviewer (cif) {
      // let viewer = window.viewer
      if (cif == '') {
        return 0
      }
      // var cifstring = cif
      // var cifstring = this.cifcontent
      var isaddcell = this.isaddcell
      this.$loadScript('/static/3Dmol-min.js').then(
        () => {
          $(function () {
            let element = $('#container-01')
            let config = { backgroundColor: 'black' }
            let viewer = $3Dmol.createViewer(element, config)
            // viewer.addSphere({ center: {x: 0, y: 0, z: 0}, radius: 10.0, color: 'green' })
            // viewer.zoomTo()
            // viewer.render()
            // viewer.zoom(0.8, 2000)
            // let cif = cifstring
            window.viewer = viewer
            // var ViewUrl = 'http://127.0.0.1:5000' + '/cif/' + '62244b018e7fa581ef3b9c19'.trim()
            // $.get(ViewUrl, function (cif) {
            // console.log(cif)
            viewer.addModel(cif, 'cif', {doAssembly: true, duplicateAssemblyAtoms: true})
            viewer.setStyle({sphere: {colorscheme: 'Jmol', scale: 0.5}, stick: {colorscheme: 'Jmol'}})
            if (isaddcell) {
              viewer.addUnitCell()
            }
            // viewer.addUnitCell()
            viewer.replicateUnitCell(Math.max(Math.floor(40 / viewer.getModel().getCrystData().a), 1),
              Math.max(Math.floor(40 / viewer.getModel().getCrystData().a), 1),
              Math.max(Math.floor(40 / viewer.getModel().getCrystData().c), 1)) // replicate unit cell
            viewer.setProjection('orthographic')
            viewer.zoomTo()
            viewer.render()
            // });
          })
        }
      )
    }
  },
  watch: {
    cifcontent: function (newValue, oldValue) {
      this.updateviewer(newValue)
    }
  },
  components: {
    // widgetWrapper
  }
}
</script>
<template>
  <!-- <widget-wrapper widgettype="pc-molecule-widget" :wid="wid">
    <div class="viewer_3Dmoljs"
      :data-pdb="pdb"
      :data-backgroundcolor="background"
      :data-style="style"
    >
    </div>
  </widget-wrapper> -->
  <!-- <div class="viewer_3Dmoljs"
      :data-pdb="pdb"
      :data-backgroundcolor="background"
      :data-style="style"
    >
    </div> -->
    <div>
    <!-- <div v-html="message">
    </div> -->
    <div id="container-01" class="mol-container"></div>
    </div>
</template>

<style scoped>
.viewer_3Dmoljs {
  height: 400px;
  width: 400px;
  position: relative;
}
.mol-container {
  width: 100%;
  height: 400px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/subcomponents/tdmolview.vue